import React from 'react';
import { Button, Card, CardContent, CardActions, Typography, Grid, Checkbox, FormControlLabel } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import * as ETVConstants from '../ETVConstants';
import dayjs from 'dayjs';

class TimeDateSettings extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			item: {},
			fromTime: ETVConstants.createTimeHoursMin(0, 0),
			toTime: ETVConstants.createTimeHoursMin(0, 0),
			fromDate: dayjs(),
			toDate: ETVConstants.createDateYearsPlus(1),
			updateDate: false,
			updateTime: false,
			showingTime: 20,
			weekdayList: [],
			needs_save: false,
			timeError:"",
		};
	}

	componentDidMount() {
		this.loadData();
	}

	componentDidUpdate(prevProps, prevState) {
		// ---- validate time every time it changes ----
		const timeChanged =
			prevState.fromTime !== this.state.fromTime ||
			prevState.toTime !== this.state.toTime;

		if (timeChanged) {
			const v = this.isTimeRangeValid(this.state.fromTime, this.state.toTime);
			// show/hide error
			if (v.msg !== this.state.timeError) {
			// avoid loops
			this.setState({ timeError: v.msg });
			}
			// if invalid, STOP any pending updateTime
			if (!v.ok && this.state.updateTime) {
			this.setState({ updateTime: false });
			return;
			}
		}

		// ---- only update when valid ----
		if (this.state.updateDate) {
			this.updateDate();
		}
		if (this.state.updateTime) {
			const v = this.isTimeRangeValid(this.state.fromTime, this.state.toTime);
			if (!v.ok) {
			this.setState({ timeError: v.msg, updateTime: false });
			return;
			}
			this.updateTime();
		}
	}	

	loadData() {
		const accessToken = localStorage.getItem("etv.access_token");
		const reqUserID = localStorage.getItem("etv.user_id");
		const url = ETVConstants.getServerBase() + "/content_library?action=get_content_item&content_id=" + this.props.content_id;
		fetch(url, { headers: { 'user_id': reqUserID, 'access_token': accessToken } })
			.then(res => res.json())
			.then((result) => {
				const contentItem = result.item;
				this.initSettings(contentItem);
			});
	}

	validateTimeRange = (from, to) => {
		if (!from || !to) return true;

		const fromStr = ETVConstants.formatTime(from);
		const toStr = ETVConstants.formatTime(to);

		// Allow 00:00 → 00:00 (means no restriction)
		if (fromStr === "00:00" && toStr === "00:00") {
			return true;
		}

		// Block equal times
		if (fromStr === toStr) {
			this.setState({
			timeError: ETVConstants.trans("error_time_equal"),
			updateTime: false
			});
			return false;
		}

		// Block invalid order
		if (to <= from) {
			this.setState({
			timeError: ETVConstants.trans("error_time_order"),
			updateTime: false
			});
			return false;
		}

		this.setState({ timeError: "" });
		return true;
	};	

	initSettings(contentItem) {
		if (!contentItem) return;

		const dFrom = contentItem.from_date ? ETVConstants.createDate(contentItem.from_date) : ETVConstants.createDateNow();
		const dTo = contentItem.to_date ? ETVConstants.createDate(contentItem.to_date) : ETVConstants.createDateYearsPlus(1);
		const dFromTime = contentItem.from_time ? ETVConstants.createTime(contentItem.from_time) : ETVConstants.createTimeHoursMin(0, 0);
		const dToTime = contentItem.to_time ? ETVConstants.createTime(contentItem.to_time) : ETVConstants.createTimeHoursMin(0, 0);
		const weekdaysL = this.createWeekdayList(contentItem.weekdays);

		this.setState({
			item: contentItem,
			fromDate: dFrom,
			toDate: dTo,
			fromTime: dFromTime,
			toTime: dToTime,
			weekdayList: weekdaysL,
			needs_save: false
		});
	}

	createWeekdayList(list) {
		if (!Array.isArray(list)) list = [];
		const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
		return days.map(day => ({ name: day, isChecked: list.includes(day) }));
	}

	toggleWeekday(index) {
		const updatedList = [...this.state.weekdayList];
		updatedList[index].isChecked = !updatedList[index].isChecked;

		this.setState({ weekdayList: updatedList }, () => {
			const selectedDays = updatedList.filter(item => item.isChecked).map(item => item.name);
			this.weekdayCallback(selectedDays);
		});
	}

	weekdayCallback(weekdayList) {
		let str = "";
		for (let i = 0; i < weekdayList.length; i++) {
			str += "&weekday=" + weekdayList[i];
		}
		const url = ETVConstants.getServerBase() + "/content_library?action=update_weekdays&content_id=" + this.props.content_id + str;
		ETVConstants.sendCMDToServerListener(url, () => {});
	}

	setFromDate = (date) => {
		if (this.state.toDate < date) {
			this.setState({ fromDate: date, toDate: date, updateDate: true });
		} else {
			this.setState({ fromDate: date, updateDate: true });
		}
	}

	setToDate = (date) => {
		if (this.state.fromDate > date) {
			this.setState({ toDate: date, fromDate: date, updateDate: true });
		} else {
			this.setState({ toDate: date, updateDate: true });
		}
	}

	resetDate() {
		this.setState({ fromDate: null, toDate: null, updateDate: true });
	}

	updateDate() {
		const from = this.state.fromDate ? ETVConstants.formatDate(this.state.fromDate) : "";
		const to = this.state.toDate ? ETVConstants.formatDate(this.state.toDate) : "";
		const url = ETVConstants.getServerBase() + "/content_library?action=set_date&content_id=" + this.props.content_id + "&from_date=" + from + "&to_date=" + to;
		ETVConstants.sendCMDToServerListener(url, () => { this.setState({ updateDate: false }); });
	}

	updateTime() {
		const from = ETVConstants.formatTime(this.state.fromTime);
		const to = ETVConstants.formatTime(this.state.toTime);
		const url = ETVConstants.getServerBase() + "/content_library?action=set_time&content_id=" + this.props.content_id + "&from_time=" + from + "&to_time=" + to;
		ETVConstants.sendCMDToServerListener(url, () => { this.setState({ updateTime: false }); });
	}

	setFromTime = (time) => {
		if (!time) return;
		this.setState({ fromTime: time, updateTime: true });
	};

	setToTime = (time) => {
		if (!time) return;
		this.setState({ toTime: time, updateTime: true });
	};

	isTimeRangeValid = (fromTime, toTime) => {
		if (!fromTime || !toTime) return { ok: true, msg: "" };

		const fromStr = ETVConstants.formatTime(fromTime);
		const toStr = ETVConstants.formatTime(toTime);

		// allow 00:00 → 00:00 (means "no restriction")
		if (fromStr === "00:00" && toStr === "00:00") return { ok: true, msg: "" };

		// block equality
		if (fromStr === toStr) {
			return { ok: false, msg: ETVConstants.trans("error_time_equal") };
		}

		// block until <= from
		if (toTime <= fromTime) {
			return { ok: false, msg: ETVConstants.trans("error_time_order") };
		}

		return { ok: true, msg: "" };
	};	

	resetTime() {
		this.setState({ fromTime: ETVConstants.createTimeHoursMin(0, 0), toTime: ETVConstants.createTimeHoursMin(0, 0), updateTime: true });
	}

	render() {
		const { fromTime, toTime, fromDate, toDate, weekdayList } = this.state;
		const editable = !this.props.disabled;

		return (
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Grid container spacing={2}>
					{/* Time Picker Card */}
					<Grid item sm={6} xs={12}>
						<Card elevation={5}>
							<CardContent>
								<Typography variant="h6" color="primary" gutterBottom>{ETVConstants.trans("select_time")}</Typography>
								<Typography style={{marginBottom:20}} variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>{ETVConstants.trans("helper_time_settings")}</Typography>
								<TimePicker
									margin="normal"
									disabled={!editable}
									id="time-picker_from"
									minutesStep={5}
									format="HH:mm"
									ampm={false}
									label={ETVConstants.trans("from_time")}
									value={fromTime}
									onChange={this.setFromTime}
								/>
								<br /><br />
								<TimePicker
									margin="normal"
									disabled={!editable}
									id="time-picker_to"
									minutesStep={5}
									format="HH:mm"
									ampm={false}
									label={ETVConstants.trans("to_time")}
									value={toTime}
									onChange={this.setToTime}
								/>
								{this.state.timeError ? (
									<Typography variant="caption" color="error" sx={{ display: "block", mb: 1 }}>
										{this.state.timeError}
									</Typography>
								) : null}
							</CardContent>
							<CardActions>
								<Button disabled={!editable} size='small' variant='contained' color="error" onClick={() => this.resetTime()}>
									{ETVConstants.trans("clear_time")}
								</Button>
							</CardActions>
						</Card>
					</Grid>

					{/* Date Picker Card */}
					<Grid item sm={6} xs={12}>
						<Card elevation={5}>
							<CardContent>
								<Typography variant="h6" color="primary" gutterBottom>{ETVConstants.trans("select_date")}</Typography>
								<Typography style={{marginBottom:20}} variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>{ETVConstants.trans("helper_date_settings")}</Typography>
								<DatePicker
									disabled={!editable}
									id="date-picker-from"
									label={ETVConstants.trans("from_date")}
									format="YYYY-MM-DD"
									value={fromDate}
									onChange={this.setFromDate}
								/>
								<br /><br />
								<DatePicker
									disabled={!editable}
									id="date-picker-to"
									label={ETVConstants.trans("until_date")}
									format="YYYY-MM-DD"
									value={toDate}
									onChange={this.setToDate}
								/>
							</CardContent>
							<CardActions>
								<Button disabled={!editable} size='small' variant='contained' color="error" onClick={() => this.resetDate()}>
									{ETVConstants.trans("clear_date")}
								</Button>
							</CardActions>
						</Card>
					</Grid>

					{/* Weekday Selector */}
					<Grid item xs={12}>
						<Card elevation={5}>
							<CardContent>
								<Typography variant="h6" color="primary" gutterBottom>{ETVConstants.trans("select_weekdays")}</Typography>
								<Grid container spacing={1}>
									{weekdayList.map((day, index) => (
										<Grid item xs={6} sm={3} key={index}>
											<FormControlLabel
												control={
													<Checkbox
														disabled={!editable}
														checked={day.isChecked}
														onChange={() => this.toggleWeekday(index)}
													/>
												}
												label={ETVConstants.trans(day.name)}
											/>
										</Grid>
									))}
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</LocalizationProvider>
		);
	}
}

export default TimeDateSettings;
